import { Brand } from "effect"
import { Link as RRLink, type LinkProps } from "react-router"

export const Link = (props: Link.Props) => {
  return <RRLink viewTransition {...props} />
}

export type Route = Brand.Branded<string, "FanProfile/Route">
const Route = Brand.nominal<Route>()

export const Routes = {
  // auth
  login: Route("/auth/login"),
  verify: Route("/auth/verify"),
  resendOtp: Route("/auth/resend-otp"),

  // app
  home: Route("/profile"),
  authenticate: Route("/profile/authenticate"),
  tourSchedule: Route("/profile/tour-schedule"),
  merchDetail: (merchSkuId: string) => Route(`/profile/merch/${merchSkuId}`),
  collection: (profileId: string) => Route(`/profile/${profileId}`),
  checkIn: Route("/check-in"),
  fanClipsNew: Route("/profile/fan-clips/new")
}

namespace Link {
  export type Props = Omit<LinkProps, "to"> & {
    to: Route
  }
}
